import {WidgetRegistry} from '@voltmoney/component';
import {BorderRadiusTokens, ColorTokens} from '@voltmoney/schema';
import React, {useEffect, useState} from 'react';
import {StyleSheet, useWindowDimensions, View} from 'react-native';
import PartnerDashBoardHeader from './partnerDashBoardHeader';
import ThemeProvider from '@voltmoney/theme';
import {getLocalStorageSync, LocalStorageType} from './configs/localStorage';
import {ROUTE_PARTNER} from './configs/types';
import {MicroFrontend} from '@voltmoney/platform';
import {ROUTE, ROUTE_MAP} from '@voltmoney/micro-frontend';
import {isMobile} from './configs/util';
import {Route} from 'workbox-routing';
import AsyncStorage from '@react-native-async-storage/async-storage';

const PartnerDashboardNew: React.FunctionComponent<{route: any}> = ({
  route,
}: any) => {
  /*** Get all params sent via URL ****/
  //Example-1
  //http://localhost:3000/partner/dashboard/helloworld
  // access route.params -> {params: 'helloworld'}
  //Example-2
  //http://localhost:3000/partner/dashboard?ref_code=12345
  // access route.params -> {ref_code: '12345'}

  const {width, height} = useWindowDimensions();
  let theme = ThemeProvider.getTheme();
  let colorMapping = theme.colors;
  let borderRadiusMapping = theme.borderRadius;


  useEffect(() => {
    const activeIndexTab = route?.params?.activeIndexTab

    const setIndex = async () => {
      await AsyncStorage.setItem("activeIndexTab", activeIndexTab)
    }
    setIndex();
  },[])


  let routeConfig = '';

    switch (route.name) {
        case ROUTE_PARTNER.INTEREST_CALCULATOR: 
            routeConfig = ROUTE.INTEREST_CALCULATOR;
            break;
        case ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO:
            routeConfig = ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO;
            break;
        default:
            routeConfig =
                route.name === ROUTE_PARTNER.AUTH
                    ? ROUTE.PARTNER_AUTH
                    : route.name === ROUTE_PARTNER.EARNING
                        ? ROUTE.EARNING
                        : route.name === ROUTE_PARTNER.CHECK_LIMIT
                            ? ROUTE.PARTNER_CHECK_LIMIT
                            : route.name === ROUTE_PARTNER.MY_ACCOUNT
                                ? ROUTE.MY_ACCOUNT
                                : route.name === ROUTE_PARTNER.DEMO_VIDEOS
                                    ? ROUTE.DEMO_VIDEOS
                                    : route.name === ROUTE_PARTNER.COLLATERAL
                                        ? ROUTE.COLLATERAL
                                        : route.name === ROUTE_PARTNER.SIGNUP
                                            ? ROUTE.PARTNER_SIGNUP
                                            : route.name === ROUTE_PARTNER.LEADS
                                                ? ROUTE.PARTNER_LEAD
                                                : route.name === ROUTE_PARTNER.ACTIVE_CUSTOMER
                                                    ? ROUTE.PARTNER_ACTIVE_CUSTOMER
                                                    : route.name === ROUTE_PARTNER.REFERRED_PARTNER
                                                        ? ROUTE.PARTNER_REFERRED_PARTNER
                                                        : route.name === ROUTE_PARTNER.CAPITAL_GAIN
                                                            ? ROUTE.PARTNER_CAPITAL_GAIN
                                                            : ROUTE.DASHBOARD;
    }

    const _isMobile = isMobile();

  useEffect(() => {
    window.scrollTo(0, 0);
    //@ts-ignore
  }, []);

  const styles = StyleSheet.create({
    dashBoardContainer: {
      width: '100%',
      height: height,
      alignItems: 'center',
      backgroundColor: !_isMobile ? 'rgb(242, 242, 242)' : '#FFFFFF',
    },
  });

  return (
    <View style={styles.dashBoardContainer}>
      <View
        style={{
          width: width,
          position: 'absolute',
          height: 60,
          borderColor: 'red',
          backgroundColor: 'white',
        }}
      />
      <View
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          maxWidth: 1600,
        }}>
        <MicroFrontend
          routeMap={ROUTE_MAP}
          routeCurrent={routeConfig ? routeConfig : ROUTE.PARTNER_DASHBOARD_V2}
          widgetRegistry={WidgetRegistry}
          extraProps={{
            setIsUserLoggedIn: true,
            partnerUserContext: getLocalStorageSync(
              LocalStorageType.USER_CONTEXT,
            ),
            // dashboardActiveId: localStorage.getItem(
            //   LocalStorageType.DASHBOARD_ACTIVE_ID,
            // ),
          }}
          //@ts-ignore
          width={'100%'}
          height={height}
          isPartnerPlatform={true}
        />
      </View>
    </View>
  );
};

export default PartnerDashboardNew;
